import { Box, Card, Stack, Typography } from '@mui/material'

export const HightWeight = ({ data }) => {
    return (
        <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
            <Card
                sx={{
                    flexBasis: '100%',
                    backgroundColor: 'background.default',
                }}
            >
                <Box p={2}>
                    <Typography>ส่วนสูง</Typography>
                    <Typography variant="h2" textAlign={'end'}>
                        {data?.find((item) => item.name === 'HEIGHT')?.value ||
                            '- -'}{' '}
                        <Typography component={'span'} variant="body2">
                            cm
                        </Typography>
                    </Typography>
                </Box>
            </Card>
            <Card
                sx={{
                    flexBasis: '100%',
                    backgroundColor: '#FFE698',
                }}
            >
                <Box p={2}>
                    <Typography>น้ำหนัก</Typography>
                    <Typography variant="h2" textAlign={'end'}>
                        {data?.find((item) => item.name === 'WEIGHT')?.value ||
                            '- -'}{' '}
                        <Typography component={'span'} variant="body2">
                            kg
                        </Typography>
                    </Typography>
                </Box>
            </Card>
        </Stack>
    )
}
